<template>
  <div>
    <Header title="教室借用增加"></Header>
    <div class="more">
      <van-field
        v-model="xnxq.mc"
        label="学年学期"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="onShow('学年学期', 'xnxq')"
        required
        readonly
      />
      <van-field
        v-model="jylx.mc"
        label="借用类型"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="onShow('借用类型', 'jylx')"
        required
        readonly
      />
      <van-field
        v-model="jsjylx.mc"
        label="教室借用类型"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="onShow('教室借用类型', 'jsjylx')"
        required
        readonly
      />
      <van-field
        v-model="jydmt.mc"
        label="是否多媒体"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="onShow('是否使用多媒体设备', 'jydmt')"
        required
        readonly
      />
      <van-field
        v-model="lxdh"
        label="联系电话"
        input-align="right"
        type="tel"
        placeholder="请点击填写"
      />
      <van-field
        v-model="rs.dm"
        input-align="right"
        type="digit"
        @keyup="format()"
        required
        placeholder="请点击填写"
      >
        <template #label>
          <span class="label-class" @click="onShow('选择', 'bgrs')">
            {{ rs.mc }}
            <van-icon name="arrow" />
          </span>
        </template>
      </van-field>
      <van-field
        v-model="jtyt"
        label="具体用途"
        input-align="right"
        type="textarea"
        placeholder="请点击填写"
        maxlength="500"
        show-word-limit
      />
      <van-field
        v-model="zc"
        label="借用周次"
        required
        input-align="right"
        type="text"
        placeholder="请点击填写"
      />
      <van-field
        v-model="xq.mc"
        label="借用星期"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        required
        @click="onShow('借用星期', 'xq')"
        readonly
      />
      <span>
        <van-field
          v-model="jc"
          label="借用节次"
          input-align="right"
          required
          readonly
        />
        <van-checkbox-group
          style="padding:0 20px"
          v-model="result"
          direction="horizontal"
          @change="change"
        >
          <van-checkbox
            :name="item.text"
            v-for="(item, index) of columns.jc"
            :key="index"
            >{{ item.text }}</van-checkbox
          >
        </van-checkbox-group>
      </span>
    </div>
    <div class="bottom-btn">
      <span class="font-style"
        >借用周次可以填写规则1-6或者不规则1,3,5,7；如果多次借用或删除借用可以点击增加或删除。（注意标点符号是英文状态下，中文标点符号无效）
      </span>
      <button @click="save()">保存</button>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      result: [],
      show: false,
      xnxq: {},
      jylx: {},
      jsjylx: {},
      jydmt: {},
      jc: {},
      xq: {},
      zc: "",
      jc: "",
      jtyt: "",
      lxdh: "",
      value: "",
      rss: "123",
      rs: {
        mc: "到场人数",
        dmmc: "dcrsorksbjs",
        dm: ""
      },
      columns: {},
      valueList: {
        label: "",
        value: "",
        item: []
      }
    };
  },
  methods: {
    change() {
      let arr = [];

      for (let el of this.result) {
        arr.push(Number(el));
      }
      arr = arr.sort();
      this.jc = arr.join(",");
    },
    async save() {
      if (
        this.jylx.dm == undefined ||
        this.jsjylx.dm == undefined ||
        this.rs.dm == "" ||
        this.zc == "" ||
        this.xq.dm == undefined ||
        this.result.length <= 0
      ) {
        this.$toast.fail("请完善必填信息！");
        return;
      }
      let reg = /^1[3456789]\d{9}|[0]{1}[0-9]{2,3}-[0-9]{7,8}$/;
      if (this.lxdh && !reg.test(this.lxdh)) {
        this.$toast.fail("手机格式不正确！");
        return;
      }

      this.value = this.zc + "#" + this.xq.dm + "#" + this.jc + ":";

      let params = {
        xnxq01id: this.xnxq.dm,
        jylx: this.jylx.dm,
        jsjylx: this.jsjylx.dm,
        jydmt: this.jydmt.dm,
        jtyt: this.jtyt,
        lxdh: this.lxdh,
        jyzcs: this.value,
        lxdh: this.lxdh,
        jtyt: this.jtyt,
        dcrsorksbjsval:this.rs.dm,

      };
      if (this.rs.mc == "到场人数") {
        params.dcrsorksbjs = 'dcrs';
      } else {
        params.dcrsorksbjs = 'ksbjs';
      }
      const res = await Api.jsjyglzdadd(params);
      if (res.code === "1") {
        this.$toast.success("保存成功");
        setTimeout(() => {
          this.$router.replace("/brrow10008/index");
        }, 1500);
      } else {
        return;
      }
    },
    format() {
      if (this.rs.dm == 0) {
        this.rs.dm = "";
      }
    },
    // 弹出选择器
    onShow(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      if (value == "xnxq" || value == "jydmt") {
        this.valueList.item = this.columns[value][0].values;
      } else {
        this.valueList.item = this.columns[value];
      }
    },
    onConfirm(value, index, value1) {
      console.log(value1);
      this.show = false;

      if (value1 == "bgrs") {
        console.log(value);
        this.rs = {
          mc: value.text,
          dmmc: value.value,
          dm: ""
        };
        return;
      }
      this[value1].mc = value.text;
      this[value1].dm = value.value;
    },
    async getList() {
      const res = await Api.getjsjyglzd();
      this.columns.jylx = res.jylxdata.map(item => {
        return {
          value: item.dm,
          text: item.dmmc
        };
      });
      this.columns.jsjylx = res.jsjylxdata.map(item => {
        return {
          value: item.dm,
          text: item.dmmc
        };
      });
      this.columns.jydmt = [
        {
          values: res.dmtdata.map((item, index) => {
            if (index == 0) {
              this.jydmt = {
                dm: item.dm,
                mc: item.dmmc
              };
            }

            return {
              value: item.dm,
              text: item.dmmc
            };
          }),
          defaultIndex: 0
        }
      ];

      this.columns.jc = res.jcdata.map(item => {
        return {
          value: item.jc,
          text: item.jc
        };
      });
      this.columns.xq = [
        {
          text: "星期一",
          value: "1"
        },
        {
          text: "星期二",
          value: "2"
        },
        {
          text: "星期三",
          value: "3"
        },
        {
          text: "星期四",
          value: "4"
        },
        {
          text: "星期五",
          value: "5"
        },
        {
          text: "星期六",
          value: "6"
        },
        {
          text: "星期日",
          value: "7"
        }
      ];
      this.columns.bgrs = [
        {
          text: "到场人数",
          value: "dcrsorksbjsval"
        },
        {
          text: "班级数",
          value: "dcrsorksbjs"
        }
      ];
      console.log(this.columns);
    },
    async getXnxqList() {
      let xnxqDefaultIndex = 0;
      const res = await Api.getXnxq();
      this.columns.xnxq = [
        {
          values: res.data.map((item, index) => {
            if (item.isdqxq === "1") {
              this.xnxqDefaultIndex = index;
              this.xnxq = {
                dm: item.xnxq01id,
                mc: item.xqmc
              };
            }
            return {
              value: item.xnxq01id,
              text: item.xqmc
            };
          }),
          defaultIndex: this.xnxqDefaultIndex
        }
      ];
    }
  },
  created() {
    this.getXnxqList();
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.more {
  padding-bottom: 200px;
  .label-class {
    display: flex;
    align-items: center;
    i {
      color: #969799;
    }
  }
}
.bottom-btn {
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 130px;
  padding: 0 5% 10px 5%;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .font-style {
    color: red;
  }
  button {
    width: 100%;
    height: 44px;
    background: #7469f8;
    border-radius: 3px;
    color: #fff;
  }
  //   button:first-child {
  //     width: 47.5%;
  //     height: 44px;
  //     background: #ecedfd;
  //     border-radius: 3px;
  //     color: #7469f8;
  //   }
  //   button:last-child {
  //     width: 47.5%;
  //     height: 44px;
  //     background: #7469f8;
  //     border-radius: 3px;
  //     color: #fff;
  //   }
}
</style>
<style lang="less">
.more {
  .van-cell__title,
  .van-cell.van-field .van-cell__title.van-field__label > span {
    width: 100px;
    height: 22px;
    font-family: PingFangSC-Light;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
  }
  .van-icon-eye {
    font-family: "iconfont" !important;
    font-size: 22px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #212f6e;
  }
  .van-icon-eye::before {
    content: "\e6be";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/roomBorrow/roomBorrow_10008/apply.vue